import { render, staticRenderFns } from "./RegisteryForm.vue?vue&type=template&id=3a2928f4&scoped=true&"
import script from "./RegisteryForm.vue?vue&type=script&lang=js&"
export * from "./RegisteryForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisteryForm.vue?vue&type=style&index=0&id=3a2928f4&lang=less&scoped=true&"
import style1 from "./RegisteryForm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2928f4",
  null
  
)

export default component.exports